import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	back: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.back',
		defaultMessage: 'Back',
		description: 'Button for going back to rotation list.',
	},
	rotationName: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.rotationName',
		defaultMessage: 'Rotation name',
		description: 'Label for rotation name.',
	},
	addRotation: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.add',
		defaultMessage: 'Add rotation',
		description: 'Button for adding rotation.',
	},
	updateRotation: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.update',
		defaultMessage: 'Update rotation',
		description: 'Button for updating rotation.',
	},
	timings: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.timings',
		defaultMessage: 'Timings',
		description: 'Section header for timings.',
	},
	selectShiftDuration: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.select-shift-duration',
		defaultMessage: 'Select shift duration',
		description: 'Label for duration selection.',
	},
	customTimings: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.custom-timings',
		defaultMessage: 'Custom timings',
		description: 'Placeholder for select when timings are customized.',
	},
	shiftFrequency: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.shift-frequency',
		defaultMessage: 'Shift frequency',
		description: 'Label of shift frequency selection.',
	},
	defineEndTime: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.define-end-time',
		defaultMessage: 'Define end time',
		description: 'Button for adding end time field.',
	},
	removeEndTime: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.remove-end-time',
		defaultMessage: 'Remove end time',
		description: 'Button for removing end time field.',
	},
	timesInScheduleTimezone: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.times-in-schedule-timezone',
		defaultMessage: 'Times are in schedule timezone',
		description:
			'Information text that suggest entered date and time will be considered in schedule timezone.',
	},
	participantListStartUpdated: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.participant-list-start-updated',
		defaultMessage: 'Participant list and start time updated.',
		description: 'Information text that suggest participant list and start time updated.',
	},
	preserveOnCallOrder: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.perserve-on-call-order',
		defaultMessage:
			'To preserve the current on-call, automatic changes have been made in the base schedule. Reverting these changes may cause the current on-call to change. Don’t worry, the actual schedule history is preserved in the final schedule.',
		description:
			'Information text that suggest updates made to participant list and start time to keep on call order same.',
	},
	undoAutomaticChanges: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.undo-automatic-changes',
		defaultMessage: 'Undo automatic changes',
		description: 'Button for removing automatic changes made to participant list and start time.',
	},
	rotation: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.rotation',
		defaultMessage: 'Rotation {label}',
		description: 'Prefix for labels. Ex. rotation start time, rotation end date.',
	},
});

export { messages };
